export default __webpack_public_path__ + "static/media/5.6c7683d9.png";